<template>
    <v-container
            id="store"
            fluid
            tag="section"
    >
        <v-card :loading="loading ? 'white' : ''">
            <v-card-title class="black white--text">
                <span class="headline">{{ store.name }}</span>
                <v-spacer></v-spacer>
                <v-btn
                    class="ml-2 mr-2 mb-0"
                    min-width="0"
                    color="#f9dbc2"
                    link
                    target="_blank"
                    :href="marketplace_url"
                >
                    <v-icon left>mdi-flower</v-icon>Boutique Imparfaite
                </v-btn>
            </v-card-title>

            <v-form
                    ref="form"
                    v-model="valid">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" >
                            <h2>{{ $t('store.store_informations') }}</h2>
                        </v-col>

                        <v-col
                                cols="12"
                                md="3"
                        >
                            <v-text-field
                                    :label="$t('global.name')"
                                    :rules="[rules.required]"
                                    v-model="store.name"
                            />
                        </v-col>
                        <v-col
                                cols="12"
                                md="3"
                        >
                            <v-text-field
                                    :label="$t('global.email')"
                                    :rules="[rules.required]"
                                    v-model="store.email"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="2"
                        >
                            <v-text-field
                                label="Nom de la boutique Imparfaite"
                                :rules="[rules.required]"
                                v-model="store.short_name"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="2"
                        >
                            <v-select
                                v-model="store.kind"
                                :items="store_kinds"
                                item-text="label"
                                item-value="value"
                                label="Type"
                                :rules="[rules.required]"
                            ></v-select>
                        </v-col>
                        <v-col
                            cols="12"
                            md="2"
                        >
                            <v-switch
                                v-model="store.opened_to_price_negotiation"
                                label="Nego"
                            ></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                                cols="12"
                                md="4"
                        >
                            <h2>Vos contacts</h2>
                        </v-col>
                        <v-col
                                cols="12"
                                md="4"
                        >
                            <v-text-field
                                    :label="$t('global.phone')"
                                    tyle="phone"
                                    prepend-icon="phone"
                                    v-model="store.phone"
                            />
                        </v-col>

                        <v-col
                                cols="12"
                                md="4"
                        >
                            <v-text-field
                                    :label="$t('global.website_url')"
                                    tyle="url"
                                    prepend-icon="web"
                                    v-model="store.website_url"
                            />
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col
                                cols="12"
                                md="4"
                        >
                            <h2>Vos vacances</h2>
                        </v-col>
                        <v-col
                                cols="12"
                                md="4"
                        >
                            <v-menu
                                    ref="menu_vacancy_start_time"
                                    v-model="menu_vacancy_start_time"
                                    :close-on-content-click="false"
                                    :return-value.sync="store.vacancy_start_datetime"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="store.vacancy_start_datetime"
                                            :label="$t('global.vacancy_start_time')"
                                            prepend-icon="event"
                                            clearable
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="store.vacancy_start_datetime" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu_vacancy_start_time = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu_vacancy_start_time.save(store.vacancy_start_datetime)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col
                                cols="12"
                                md="4"
                        >
                            <v-menu
                                    ref="menu_vacancy_end_datetime"
                                    v-model="menu_vacancy_end_datetime"
                                    :close-on-content-click="false"
                                    :return-value.sync="store.vacancy_end_datetime"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="store.vacancy_end_datetime"
                                            :label="$t('global.vacancy_end_time')"
                                            prepend-icon="event"
                                            clearable
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="store.vacancy_end_datetime" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu_vacancy_end_datetime = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu_vacancy_end_datetime.save(store.vacancy_end_datetime)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col cols="6" md="6" sm="12">
                            <v-col cols="12">
                                <h2>Adresse livraison</h2>

                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                        :label="$t('global.recipient_name')"
                                        :rules="[rules.required]"
                                        v-model="store.address.recipient_name"

                                />
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                        :label="$t('global.address_line_1')"
                                        :rules="[rules.required]"
                                        v-model="store.address.line1"

                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                        :label="$t('global.address_line_2')"
                                        v-model="store.address.line2"

                                />
                            </v-col>
                            <v-row>
                                <v-col cols="4" md="4">
                                    <v-text-field
                                            :label="$t('global.postal_code')"
                                            :rules="[rules.required]"
                                            v-model="store.address.postal_code"
                                    />
                                </v-col>
                                <v-col cols="4"
                                       md="4"
                                >
                                    <v-text-field
                                            :label="$t('global.city')"
                                            :rules="[rules.required]"
                                            v-model="store.address.city"
                                    />
                                </v-col>

                                <v-col cols="4"
                                       md="4"
                                >
                                    <v-select
                                            v-model="store.address.country_code"
                                            :label="$t('global.country')"
                                            :items="country"
                                            item-text="label"
                                            item-value="value"
                                    ></v-select>
                                </v-col>
                            </v-row>

                        </v-col>

                        <v-col cols="6" md="6" sm="12">
                            <v-col
                                    cols="12"
                            >
                                <h2>{{ $t('store.billing_informations') }}</h2>

                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <template v-if="store.stripe_account_id !== null">
                                    <v-text-field
                                        :label="$t('global.stripe_account_id')"
                                        v-model="store.stripe_account_id"
                                        disabled
                                    />
                                </template>
                                <template v-else>
                                    <v-btn @click="showTosDialog" color="green darken-1">
                                        <v-icon left>mdi-cash</v-icon>Créer mon compte Stripe Connect
                                    </v-btn>
                                </template>
                            </v-col>
                            <v-col
                                    cols="12"
                            >
                                <v-text-field
                                        :label="$t('global.recipient_name')"
                                        :rules="[rules.required]"
                                        v-model="store.billing_address.recipient_name"

                                />
                            </v-col>
                            <v-col
                                    cols="12"
                            >
                                <v-text-field
                                        :label="$t('global.address_line_1')"
                                        :rules="[rules.required]"
                                        v-model="store.billing_address.line1"

                                />
                            </v-col>

                            <v-col
                                    cols="12"
                            >
                                <v-text-field
                                        :label="$t('global.address_line_2')"
                                        v-model="store.billing_address.line2"

                                />
                            </v-col>

                            <v-row>
                                <v-col cols="4" md="4">
                                    <v-text-field
                                            :label="$t('global.postal_code')"
                                            :rules="[rules.required]"
                                            v-model="store.billing_address.postal_code"
                                    />
                                </v-col>
                                <v-col cols="4" md="4">
                                    <v-text-field
                                            :label="$t('global.city')"
                                            :rules="[rules.required]"
                                            v-model="store.billing_address.city"
                                    />
                                </v-col>
                                <v-col cols="4" md="4">
                                   <v-select
                                            v-model="store.billing_address.country_code"
                                            :label="$t('global.country')"
                                            :items="country"
                                            item-text="label"
                                            item-value="value"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-col
                                    cols="12"
                            >
                                <v-text-field
                                        :label="$t('global.denomination')"
                                        v-model="store.billing_name"
                                />
                            </v-col>

                            <v-col
                                    cols="12"
                            >
                                <v-textarea
                                        :label="$t('global.additional_information')"
                                        v-model="store.billing_address.additional_information"
                                />
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-col
                            cols="12"
                    >
                        <v-btn
                                @click="save"
                                color="primary"
                        >
                            <template v-if="!store.id">{{ $t('store.save_store') }}</template>
                            <template v-if="store.id">{{ $t('store.update_store') }}</template>
                        </v-btn>
                    </v-col>
                </v-container>
            </v-form>
        </v-card>
        <v-snackbar
                v-model="snackbar"
                :color="color"
        >
            {{ message }}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                {{ $t('global.close') }}
            </v-btn>
        </v-snackbar>
        <v-dialog
            v-model="dialog.visible"
            width="500"
        >
            <v-card
                :loading="dialog.loading"
            >
                <v-card-title class="headline grey lighten-2">
                    {{ $t('store.stripe.connect_account_create') }}
                </v-card-title>

                <v-card-text>
                    <p class="pt-5 pb-5">
                        En cliquant sur le bouton suivant, vous acceptez <a href="#">nos Conditions Générales d\'Utilisation</a>
                        ainsi que les <a href="https://stripe.com/fr/connect-account/legal#translation" target="_blank">Conditions d\'Utilisation des Comptes Connectés Stripe</a>
                    </p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="createConnectAccount()"
                    >
                        J'accepte
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'Store',

        beforeMount() {
            this.load();
        },

        data() {
            return {
                store_kinds: [
                    {label:'Passionné', value:'PASSIONATE'},
                    {label:'Pro Online', value:'PRO_ONLINE'},
                    {label:'Pro Offline', value:'PRO_OFFLINE'},
                ],
                dialog: {
                    loading: false,
                    visible : false
                },
                country: [
                    {'label': 'France', 'value' : 'FR'}
                ],
                snackbar: false,
                color: 'info',
                message: '',
                store: {
                    address: {},
                    billing_address: {}
                },
                marketplace_url : '',
                valid: false,
                loading: false,
                rules: {
                    required: value => !!value || this.$i18n.t('global.required'),
                },
            };
        },

        methods: {
            load() {
                if (this.$route.params.id) {
                    this.loading = true;
                    this.$axios.get('stores/' + this.$route.params.id)
                        .then(response => {
                            this.loading = false;
                            this.store = response.data;
                            this.marketplace_url = process.env.VUE_APP_MARKETPLACE_URL + this.store.marketplace_url;
                        });
                }

            },
            showTosDialog() {
                this.dialog.visible = true;
            },
            createConnectAccount() {
                this.dialog.loading = true;
                this.$axios.post('stores/' + this.$route.params.id + '/stripes/accounts', {})
                    .then(() => {
                        this.dialog.loading = false;
                        this.snackbar = true;
                        this.message = this.$i18n.t('store.stripe.connect_account_success');
                        this.color = 'info';
                        this.$router.push({name: 'Admin Store', params: {id: this.store.id}});
                        this.load();
                        this.dialog.visible = false;
                    })
                    .catch(error => {
                        this.dialog.loading = false;
                        this.snackbar = true;
                        this.message = this.$i18n.t('store.stripe.connect_account_failed') + error.response.data['hydra:description'];
                        this.color = 'error';
                        this.dialog.visible = false;
                    });
            },
            save() {
                this.$refs.form.validate();
                if (!this.valid) return false;

                this.loading = true;
                this.$axios.put('stores/' + this.$route.params.id, this.store)
                    .then(response => {
                        this.loading = false;
                        this.store = response.data;
                        this.snackbar = true;
                        this.message = this.$i18n.t('store.store_saved');
                        this.color = 'info';
                        this.$router.push({name: 'Admin Store', params: {id: this.store.id}});
                    })
                    .catch(() => {
                        this.loading = false;
                        this.snackbar = true;
                        this.message = this.$i18n.t('store.store_save_failed');
                        this.color = 'error';
                });
            },
        },
        computed: {
            ...mapGetters(['isSeller']),
        },
    }
</script>
